import SortPopup, { SortOption } from "../../../../components/sort_popup/sort_popup";

export type SurveysSortOption = "newest" | "oldest";

export const DEFAULT_SURVEYS_SORT_OPTION: SurveysSortOption = "newest";

const OPTIONS: SortOption<SurveysSortOption>[] = [
  { value: "newest", label: "New to old" },
  { value: "oldest", label: "Old to new" },
];

export function surveysSortOptionLabel(option: SurveysSortOption): string {
  return OPTIONS.find((o) => o.value === option)!.label;
}

// Surveys' list/response endpoints only support a single sortOrder param
// (no sortBy) - this maps the single date-based choice straight to it.
export function surveysSortOptionToSortOrder(option: SurveysSortOption): "ASC" | "DESC" {
  return option === "newest" ? "DESC" : "ASC";
}

export default function SortSurveysPopup({
  open,
  onClose,
  sortOption,
  setSortOption,
}: {
  open: boolean;
  onClose: () => void;
  sortOption: SurveysSortOption;
  setSortOption: (option: SurveysSortOption) => void;
}) {
  return (
    <SortPopup
      open={open}
      onClose={onClose}
      title="Sort Surveys"
      options={OPTIONS}
      value={sortOption}
      onApply={setSortOption}
    />
  );
}
